import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { update } from 'lodash-es';
import { EComItemTypeCustomFieldSearchDto } from '../shared/dto/ecom-item-type-custom-field-search.dto';
import { EComItemTypeCustomFieldItemValueDto } from '../shared/dto/ecom-item-type-custom-field-value.dto';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';
import { EcomItemTypeCustomFieldService } from '../shared/ecom-item-type-custom-field.service';
import { EcomService } from '../shared/ecom.service';
@Component({
  selector: 'wl-ecom-item-edit-custom-fields',
  templateUrl: './ecom-item-edit-custom-fields.component.html',
  styleUrls: ['./ecom-item-edit-custom-fields.component.less'],
    standalone: false
})
export class EComItemEditCustomFieldsComponent implements OnInit, OnChanges {
  @Input() eCommerceItem: EcomItemDto;
  @Output() customFieldItemValueChanged = new EventEmitter<EcomItemDto>();
  eComItemTypeCustomFieldItemValues: EComItemTypeCustomFieldItemValueDto[] = [];
  displayCustomFields: boolean = false;

  constructor(private _ecomService: EcomService, private _ecomItemTypeCustomFieldService: EcomItemTypeCustomFieldService) {}

  ngOnInit(): void {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.displayCustomFields = false;
    if (changes.eCommerceItem) {
      let customFieldSearchDto = {} as EComItemTypeCustomFieldSearchDto;

      let result = await this._ecomItemTypeCustomFieldService.search(customFieldSearchDto);

      this.eComItemTypeCustomFieldItemValues = result?.Result.map<EComItemTypeCustomFieldItemValueDto>((x) => {
        return {
          ItemID: this.eCommerceItem?.ItemId,
          CustomFieldName: x.Name,
          ItemTypeCustomFieldID: x.ItemTypeCustomFieldId,
          Value: '',
          ItemTypeID: this.eCommerceItem?.ItemTypeId,
          ItemTypeCustomFieldValueID: 0,
        };
      });

      if (this.eCommerceItem?.ItemId > 0) {
        this.eComItemTypeCustomFieldItemValues.forEach((value) => {
          var customFieldvalues = this.eCommerceItem?.CustomFieldValues?.find(
            (c) => c.ItemTypeCustomFieldID == value.ItemTypeCustomFieldID
          );
          if (customFieldvalues) {
            value.Value = customFieldvalues.Value;
            value.ItemTypeCustomFieldValueID = customFieldvalues.ItemTypeCustomFieldValueID;
          }
        });
      }
      this.displayCustomFields = true;
    }
  }

  changeCustomFieldValues() {
    this.eCommerceItem.CustomFieldValues = this.eComItemTypeCustomFieldItemValues.filter((cv) => cv.Value != '' || cv.Value != '');
    this.updateCustomFieldValues();
  }

  updateCustomFieldValues() {
    this.customFieldItemValueChanged.emit(this.eCommerceItem);
  }
}
